module.exports = __webpack_public_path__ + "img/icon-download-contract.39f302b2.svg";